import { Input } from '@aloft/toolkit-sui';

import { Controller, useFormContext } from 'react-hook-form';

import { Td } from '../table.tsx';
import { FilterRangeWrapperProps } from './types.ts';

export const PriceRangeInputs = ({ minName, maxName }: FilterRangeWrapperProps) => {
  const { control } = useFormContext();
  return (
    <>
      <Td type="editable">
        <Controller
          name={minName}
          control={control}
          render={({ field, fieldState }) => (
            <Input
              id={minName}
              size="sm"
              type="aloftPrice"
              currencyCode="usd"
              placeholderText="Minimum"
              autoFocus
              border="hidden"
              borderRadius={0}
              isInvalid={fieldState.invalid}
              onClear={() => {
                field.onChange('');
              }}
              {...field}
            />
          )}
        />
      </Td>
      <Td type="editable">
        <Controller
          name={maxName}
          control={control}
          render={({ field, fieldState }) => (
            <Input
              id={maxName}
              size="sm"
              type="aloftPrice"
              currencyCode="usd"
              placeholderText="Maximum"
              border="hidden"
              borderRadius={0}
              autoFocus
              isInvalid={fieldState.invalid}
              onClear={() => {
                field.onChange('');
              }}
              {...field}
            />
          )}
        />
      </Td>
    </>
  );
};
